import React, { Fragment, useMemo } from "react";
import { MapContainer, ScaleControl, ZoomControl } from "react-leaflet";
import MapLayers from "./map/MapLayers";
import ControlMapCenter from "./map/ControlMapCenter";
import FullScreenControl from "./map/FullScreenControl";

export default function AixmMap({
  airportLocation,
  zoomLevel,
  selctedAirport,
}) {
  const aixmMapE = useMemo(() => {
    return (
      <MapContainer
        center={airportLocation}
        zoom={zoomLevel}
        zoomControl={false}
      >
        <ControlMapCenter
          airportLocation={airportLocation}
          zoomLevel={zoomLevel}
        />
        <FullScreenControl />
        <ZoomControl position="bottomright" />
        <MapLayers />
        <ScaleControl position="topleft" />
      </MapContainer>
    );
  }, [airportLocation, zoomLevel, selctedAirport]); // eslint-disable-line

  return <Fragment>{aixmMapE}</Fragment>;
}
